import React from 'react'

const IconCopyButton = ({ isDark = false }) => {
  return isDark ? (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' fill='black' />
      <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' stroke='#636B73' />
      <mask
        id='mask0_18827_11873'
        style={{
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x='6'
        y='6'
        width='20'
        height='20'
      >
        <rect x='6' y='6' width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_18827_11873)'>
        <path
          d='M12.4167 20.1663V8.83301H21.75V20.1663H12.4167ZM13.0833 19.4997H21.0833V9.49967H13.0833V19.4997ZM10.25 22.333V11.5126H10.9167V21.6663H19.0704V22.333H10.25Z'
          fill='#D0D0CE'
        />
      </g>
    </svg>
  ) : (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' fill='white' />
      <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' stroke='#D8D8D6' />
      <mask
        id='mask0_18827_14475'
        style={{
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x='6'
        y='6'
        width='20'
        height='20'
      >
        <rect x='6' y='6' width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_18827_14475)'>
        <path
          d='M12.4167 20.1663V8.83301H21.75V20.1663H12.4167ZM13.0833 19.4997H21.0833V9.49967H13.0833V19.4997ZM10.25 22.333V11.5126H10.9167V21.6663H19.0704V22.333H10.25Z'
          fill='black'
        />
      </g>
    </svg>
  )
}

export default IconCopyButton
